import { WebStorageFilterOptionsKeys, WebStorageUserSessionKeys } from 'apps/core/vars/web-storage';
import { useCallback } from 'react';
import { useAppDispatch } from 'store/hooks';
import { pageActions } from 'store/slices/page';
import { removeWebStorage } from 'utils/web-storage';
import { mapFiltersStorageKeyToFavoriteFiltersStorageKey } from 'apps/shared/data-access/utils/page-filter-mappers';

const useLogout = () => {
  const dispatch = useAppDispatch();

  const logout = useCallback(() => {
    // Clear all web storage keys related to user session
    Object.values(WebStorageUserSessionKeys).forEach((key) => removeWebStorage(key));

    // Clear all web storage keys related to filters
    Object.values(WebStorageFilterOptionsKeys).forEach((key) => {
      const favoriteFiltersKey = mapFiltersStorageKeyToFavoriteFiltersStorageKey(key);
      removeWebStorage(favoriteFiltersKey);
    });

    dispatch(pageActions.logout());
  }, [dispatch]);

  return logout;
};

export default useLogout;
